<template>
    <div class="page-with-top-bar">

        <div class="flex justify-between w-full mt-4 below-top-bar">
        </div>

        <div class="border border-blue-lighter rounded bg-blue-lightest p-2">

            <div class="flex w-full">

                <div class="w-1/6 pr-4">
                    <label>{{ $t('code') }}</label>
                    <input v-model="newForm.code" type="text" name="" class="input" ref="codeField">
                </div>

                <div class="w-1/6 pr-4">
                    <label>{{ $t('name') }}</label>
                    <input v-model="newForm.name" type="text" name="" class="input">
                </div>


                <div class="w-2/6 pr-4">
                    <label>{{ $t('description') }}</label>
                    <input v-model="newForm.description" type="text" name="" class="input">
                </div>

                <div class="w-1/6 pr-4">
                    <label>&nbsp;</label>
                    <button class="btn btn-green" type="button" @click="saveTemplate()">
                        <i class="fas fa-plus mr-1"></i> {{ $t('add') }}
                    </button>
                </div>

            </div>

        </div>

        <div class="panel">
            <div v-if="!loaded" class="my-4 text-center">
                <scale-loader></scale-loader>
            </div>
            <div v-else>
                <div class="flex flex-wrap w-full mt-4">
                    <section class="w-full">
                        <b-table icon-pack="fas" :data="templates" :paginated="isPaginated" :per-page="perPage"
                            :bordered="true" :current-page.sync="currentPage" :pagination-simple="isPaginationSimple"
                            :default-sort-direction="defaultSortDirection" v-if="loaded">
                            <template>

                                <b-table-column field="code" sortable>
                                    <template v-slot:header="">{{ $t('code') }}</template>
                                    <template v-slot="props">{{ props.row.code }}</template>
                                </b-table-column>

                                <b-table-column field="name" sortable>
                                    <template v-slot:header="">{{ $t('name') }}</template>
                                    <template v-slot="props">{{ props.row.name }}</template>
                                </b-table-column>

                                <b-table-column field="description" sortable>
                                    <template v-slot:header="">{{ $t('description') }}</template>
                                    <template v-slot="props">{{ props.row.description }}</template>
                                </b-table-column>

                                <b-table-column field="actions" width=100 sortable>
                                    <template v-slot:header="">{{ $t('actions') }}</template>
                                    <template v-slot="props">
                                        <div class="flex items-center justify-around w-full h-full">
                                            <b-tooltip :label="$t('remove')" position="is-left" type="is-danger">
                                                <div @click="deleteTemplate(props.row.id)"
                                                    class="flex cursor-pointer text-red">
                                                    <b-icon pack="fas" icon="trash-alt" />
                                                </div>
                                            </b-tooltip>
                                        </div>
                                    </template>
                                </b-table-column>
                            </template>
                            <template slot="bottom-left">
                                <b-icon pack="fas" class="flex text-blue" icon="folder"></b-icon>
                                <b>{{ $t("total") }}</b>: {{ this.templates.length }}
                            </template>

                            <template #empty>
                                <div class="has-text-centered">{{ $t('no_results') }}</div>
                            </template>

                        </b-table>
                    </section>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
import axios from 'axios'
import ScaleLoader from "vue-spinner/src/ScaleLoader.vue";

    export default {
    middleware: 'auth',
    title: 'permitting',
    components: {
        ScaleLoader,
    },
    computed: {
        ...mapGetters({
            company: 'app/company',
        }),
    },
    data: () => ({
        isPaginated: true,
        isPaginationSimple: false,
        defaultSortDirection: 'asc',
        currentPage: 1,
        perPage: 20,
        loaded: false,
        newForm: { code: '', name: '', description: '' },
        templates: [],
    }),
    mounted () {
        this.getTemplates();
    },
    methods: {
        async saveTemplate() {
            let url = "/api/v2/permitting-template"

            let postData = Object.assign({ company_id: this.company.id }, this.newForm)

            // Enviamos el form
            try {
                const { data } = await axios.post(url, postData)
                if (data ) {
                    this.$notify.success('success_editing')
                    this.getTemplates()
                    this.newForm = { code: '', name: '', description: '' }
                } 
            } catch (error) {
                if (error.response && error.response.status === 422) {
                    error.error_msg =
                        error.response.data.errors[
                        Object.keys(error.response.data.errors)[0]
                        ][0];
                }
                // Mostramos el error
                this.$toast.open({
                    message: error.error_msg || this.$t("assignment_update_error"),
                    type: "is-danger",
                    position: "is-top-right",
                });
            }
        },
        async getTemplates(){
            
            this.loaded = false
            let url = `/api/v2/company/${this.company.id}/permitting-templates`
            try {
                const { data } = await axios.get(url)
                if (data.templates.data) {
                    this.templates = data.templates.data                    
                    this.loaded = true
                }
            } catch (error) {
                this.$notify.error('error_fetching_data')
            }
        },
        async deleteTemplate(templateId) {
            let url = `/api/v2/permitting-template/${templateId}`
            // Enviamos la solicitud de eliminación
            try {
                const { data } = await axios.delete(url)
                
                if (data && data.success) {
                    this.$notify.success('success_deleting_generic')
                    this.getTemplates()
                } else {
                    this.$notify.error('error_saving')
                }
            } catch (error) {
                this.$toast.open({
                    message: error.message || this.$t("error_saving"),
                    type: "is-danger",
                    position: "is-top-right",
                });
            }
        },
    },
   
        
    }
</script>

<style lang="scss" scoped>

</style>